import request from "@/utils/request";

export function IndexPermemissions() {
  return request({
    url: "api/admin/permissions",
    method: "get"
  });
}
